module.exports = __webpack_public_path__ + "img/bannerIcon.987cbdca.png";